export const environment = {
	name: "app.arch.platform",
	cognito: {
		UserPoolId: "us-east-1_Xv2mfQnxX",
		ClientId: "62nilcdn9uqsu8l3jo13sm7gap",
	},
	googleMaps: {
		apiKey: "AIzaSyBB5t8Cx76ZvEXsYnJrhJDQZl3rgr2ZcyA",
	},
	workspacesEndpoint: "https://oblivion.platform.arch.app/workspaces",
	coreEndpoint: "https://284ut4z2ld.execute-api.us-east-1.amazonaws.com/prod",
	marketingEndpoint:
		"https://g2os63ixzi.execute-api.us-east-1.amazonaws.com/prod",
	inventoryEndpoint:
		" https://svlbav8il1.execute-api.us-east-1.amazonaws.com/prod",
	communicationsEndpoint:
		"https://z5w4odtaw4.execute-api.us-east-1.amazonaws.com/prod",
	calendaringEndpoint:
		"https://ykxuhj1hkf.execute-api.us-east-1.amazonaws.com/prod",
	applicationsEndpoint:
		"https://hekpxgo0ch.execute-api.us-east-1.amazonaws.com/prod",
	analyticsEndpoint:
		"https://5v70nvf2m4.execute-api.us-east-1.amazonaws.com/prod",
	propertyWebsiteEndpoint:
		"https://kosey8ltb0.execute-api.us-east-1.amazonaws.com",
	propertyAssetsEndpoint:
		"https://kosey8ltb0.execute-api.us-east-1.amazonaws.com",
	emailMarketingEndpoint:
		"https://kbec5wf2d5.execute-api.us-east-1.amazonaws.com/prod",
	token: "48FDi8PvS4hNDJUpyaGtnPYwKXt3u71g",
	tinyApiKey: "v559p27t6861urecmvgg96jn7n21uu9p4jvw54lk9uepptv7",
	adobeClientId: "e574e07c445f46898ffc8a37ccbd0271",
	firebase: {
		apiKey: "AIzaSyDcqpWRExoc1KjFDlIJXJNXgfbAGIZDFn0",
		authDomain: "arch-8d18d.firebaseapp.com",
		projectId: "arch-8d18d",
		storageBucket: "arch-8d18d.appspot.com",
		messagingSenderId: "324791791615",
		appId: "1:324791791615:web:d5e0c0b7242aaece0581ca",
		measurementId: "G-WVSCTBZDJR",
		vapidKey:
			"BCOmjt3AMpDbCpqPS4PBjDkq0gDews32QLe_uDcmvzQvrHSe_Zl5tlhq1NxW5Y7draibM8WMVgqDbXN6yfK_08M",
	},
	openReplay: {
		projectKey: "vnwryGmE1nVrgba4bp77",
	},
	twilioAccountSid: "AC182849cc14c7daed682d4b5b6e7f47d0",
	replicache: {
		name: "app.arch.platform",
		schemaVersion: "1",
		licenseKey: "lb243aaf3f3e84124ac7ae3b5b90428b7",
		iot: {
			endpoint: "wss://iot.oblivion.platform.arch.app/mqtt",
			topicPrefix: "app.arch.platform.oblivion",
		},
		authorizedEndpoint: "https://oblivion.platform.arch.app/authorized",
		statusEndpoint: "https://oblivion.platform.arch.app/status",
		pullEndpoint: "https://oblivion.platform.arch.app/pull",
		pushEndpoint: "https://oblivion.platform.arch.app/push",
		experimental: {
			pushEnabled: false,
		},
	},
	uploadApplicationDocumentCredentials: {
		accessKey: "AKIATGLVDZ6EXGKGSTV7",
		secretKey: "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",
	},
	uploadContentCredentials: {
		accessKey: "AKIATGLVDZ6EZBE3BKXR",
		secretKey: "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",
	},
};
